<template>
    <div class="w-100">
        <div class="d-flex">
            <div class="w-100 card text-start p-3 mb-3">
                <div class="d-flex justify-content-between">
                    <div class="mt-2 fw-bold text-uppercase">
                        <p>{{categoryProduct.parent_category_name  ||  "" }} / {{categoryProduct.name  ||  "" }} <span class="ms-2">
                                <font-awesome-icon icon="fa-solid fa-pencil" />
                            </span></p>
                    </div>
                </div>
                <div class="d-flex justify-content-between fw-bold mt-2">
                    <div>
                        <p>Created By : {{categoryProduct?.created_by_name || ""}} -
                            {{filters.dateSimple(categoryProduct?.created_date)}}</p>
                    </div>
                    <div>
                        Products Count : {{categoryProduct ? categoryProduct.product_count  : 0}}
                    </div>
                    <div>
                        <button :class="pickProduct?.length > 0 ? '' : 'disabled'" type="button"
                            class="btn btn-danger text-white shadow-sm rounded p-2 text-uppercase rounded"
                            data-bs-toggle="modal" data-bs-target="#exampleModal">Transfer
                            Category</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <p class="fw-bold modal-title" id="exampleModalLabel" >Transfer Category</p>
                    </div>
                    <div class="modal-body">
                        <div class="row mb-3 ms-3">
                            <label class="col-sm-4 col-form-label fw-bold text-start">
                                Category Name
                            </label>
                            <div class="col-md-6 ms-3">
                                <div class="row">
                                    <select class="form-control fw-bold" v-model="parentProduct"
                                        @change="getChildCategory">
                                        <option value="">Select Category</option>
                                        <option v-for="category in parentProducts" :key="category.id"
                                            :value="category.id">
                                            {{category.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row ms-3">
                            <label class="col-sm-4 col-form-label fw-bold text-start">
                                Sub Category Name
                            </label>
                            <div class="col-md-6 ms-3">
                                <div class="row">
                                    <select class="form-control fw-bold" v-model="childProduct">
                                        <option value="">Select Sub Category</option>
                                        <option v-for="category in childProducts" :key="category.id"
                                            :value="category.id">
                                            {{category.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-3 d-flex justify-content-start">
                        <button type="button" class="ms-4 btn btn-danger text-white shadow-sm rounded"
                                :class="parentProduct && childProduct ? '' : 'disabled'"
                                data-bs-dismiss="modal" @click="transferProduct">
                          Transfer Category
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="alert alert-info" role="alert" v-if="showMessage">
            <span>{{message.text}}</span>
            <router-link
                :to="'/products/category/list-category-product/'+this.childProduct"
                class="text-decoration-none"
            >
            {{ message.linkText}}
          </router-link>
        </div>

        <TableBasic :payload="payload" @onChange="changeParameter">
          <template v-slot:table_head>
            <span class="fw-bold">Product List</span>
          </template>
          <template v-slot:name="{ data }">
            <Image
                v-if="data.image_url"
                :src="filters.imageParse(data.image_url)" 
                :width="36" 
                :height="36"
                className="rounded me-3" 
            />
            <router-link
                :to="`/products/detail/${data.id}`"
                class="text-decoration-none"
            >
                {{ data.name }}
            </router-link>
          </template>
          <template v-slot:price_regular="{ data, value }">
            <span v-if="data.is_variant" class="text-capitalize">{{ data.price_displayed }}</span>
            <template v-else>
                <div v-if="value > data.price_sale" class="d-flex text-capitalize">
                    <span class="text-muted me-2" style="text-decoration: line-through">
                    {{ filters.rupiah(value) }}
                    </span>
                    <span>{{ filters.rupiah(data.price_sale) }}</span>
                </div>
                <span v-else class="text-capitalize">{{ filters.rupiah(value) }}</span>
            </template>
          </template>
          <template v-slot:product_status="{data, value}">
            <div v-if="value == 'Published'">
                <div v-if="data.stock_current > 0">
                    Live In Stock
                </div>
                <div v-else>
                    Live Out Of Stock
                </div>
            </div> 
            <div v-else>
                {{value}}
            </div> 
          </template>
          <template v-slot:id="{ data }">
            <router-link
                :to="`/products/detail/${data.id}`"
                class="text-decoration-none"
            >
                {{ data.id }}
            </router-link>
          </template>
        </TableBasic>
    </div>
</template>

<script>
    import TableBasic from "@/components/TableBasic.vue";
    import Image from "@/components/Image.vue";
    export default {
        components: {
            TableBasic,
            Image
        },
        created() {
            var currentUrl = this.$route.path.split("/");
            this.id = currentUrl[currentUrl.length - 1]
        },
        data() {
            return {
                id: "",
                payload: {
                    header: [{
                            key: "id",
                            label: "PRODUCT ID",
                            class: "text-start w-25",
                        },
                        {
                            key: "name",
                            label: "PRODUCT NAME",
                            class: "text-start",
                        },
                        {
                            key: "price_regular",
                            label: "PRODUCT PRICE",
                            class: "text-start",
                        },
                        {
                            key: "product_status",
                            label: "PRODUCT STATUS",
                            class: "text-start text-uppercase",
                        },
                        {
                            key: "stock_current",
                            label: "STOCK",
                            class: "text-start",
                        },
                    ],
                    value: [],
                    pickItems: [],
                    checkbox: true,
                    filter: false,
                    search: true,
                    totalRows: 1,
                    currentPage: 1,
                    perPage: 10,
                    pageOptions: [10, 25, 50, 100],
                    searchPlaceholder: 'Search by name',
                },
                showMessage: false,
                message: {text: "", linkText: ""},
                parentProducts: [],
                childProducts: [],
                pickProduct: [],
                parentProduct: "",
                childProduct: "",
                categoryProduct: {}
            };
        },
        watch: {
          requestPayload: {
              handler: function (newVal, oldVal) {
                const isChange = JSON.stringify(newVal) !== JSON.stringify(oldVal)
                console.log({newVal, oldVal, isChange})
                if(isChange) {
                  this.getData()
                }
              },
              deep: true,
          },
        },
        computed: {
          requestPayload(){
            return {
                perPage: this.payload.perPage,
                currentPage: this.payload.currentPage,
                keyword: this.payload.keyword || "",
            }
          }
        },
        methods: {
            handlePickName(data) {
                if(!this.payload.value?.length) return
                let result = data.map(val=>{
                    return this.payload.value.find(x=>x.id == val)?.name
                })
                this.pickName = result
            },
            changeParameter(value) {
                this.payload.perPage = value.per_page
                this.payload.currentPage = value.current_page
                this.pickProduct = value.pick_items
                this.payload.keyword = value.search
                this.handlePickName(value.pick_items)
            },
            async getData() {
                try{
                    this.$store.dispatch("setLoadingGlobal", true)
                    let payload = {
                        page: this.payload.currentPage,
                        size: this.payload.perPage,
                        category_product_id: this.id,
                        keyword: this.payload.keyword,
                        with_trashed: "true"
                    }
    
                    this.categoryProduct = await this.$store.dispatch("product/getDetailCategoryProduct", this.id)
                    const response = await this.$store.dispatch("product/getAllProduct", payload)
                    this.payload.value = response.items
                    this.payload.totalRows = response.count
                }catch(err){
                    console.log({err})
                }finally{
                    this.$store.dispatch("setLoadingGlobal", false)
                }
            },
            async getCategory() {
                const payload = {
                    page: 1,
                    size: 10000,
                    level: 1
                }
                await this.$store.dispatch("product/getAllCategoryProduct", payload)
                this.parentProducts = this.$store.getters['product/parentProductItems']

            },
            async getChildCategory() {
                const payload = {
                    page: 1,
                    size: 10000,
                    level: 2,
                    noLoading: true
                }
                await this.$store.dispatch("product/getAllCategoryProduct", payload)
                this.childProducts = this.$store.getters['product/childProductItems'](this.parentProduct)
            },
            async transferProduct() {
                try {
                    const payload = {
                        "category_product_id": this.childProduct,
                        "product_ids": this.pickProduct
                    }
                    await this.$store.dispatch("product/transferCategoryProduct", payload)
                    this.showMessage = true
                    this.message = {
                        text: `${this.pickName.join(', ')} has been successfully transferred to ${this.parentProducts.find(item => item.id === this.parentProduct)?.name} > `,
                        linkText: `${this.childProducts.find(item => item.id === this.childProduct)?.name}`,
                        }
                    this.getData()
                    this.payload.pickItems = []
                    setTimeout(() => {
                        this.showMessage = false; 
                    }, 5000);
                } catch (error) {
                  this.$swal({
                    title: error.response?.data?.errorMessage || error.message,
                    icon: "warning",
                    timer: 2000,
                  })
                }
            }
        },
        mounted() {
            this.getData()
            this.getCategory()
        },
    };
</script>

<style></style>
